// src/atoms/auth.ts
import { atom } from 'recoil'

export interface AuthState {
  id: number
  account: string
  username: string
  email: string | null
  profileImage: string | null
  name: string | null
  phone: string | null
  birthDate: string | null
  gender: string | null
  address: string | null
  isPremium: string | Date | null
  isAdmin: number | null
  serviceDeadline: string | null
  createdAt: string | null
}

export const authState = atom<AuthState>({
  key: 'authState',
  default: {
    id: 0,
    account: '',
    username: '',
    email: null,
    profileImage: null,
    name: null,
    phone: null,
    birthDate: null,
    gender: null,
    address: null,
    isPremium: null,
    isAdmin: 0,
    serviceDeadline: null,
    createdAt: null
  }
})

export const authInitializedState = atom<boolean>({
  key: 'authInitializedState',
  default: false
})
